import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { Entities } from 'cio/utils/metrics/common';
import BaseController from './controller';
import Transition from '@ember/routing/-private/transition';

import MetricsService from 'cio/services/metrics';
import Model from '@ember-data/model';

export default class OverviewRoute extends Route {
  templateName = 'base/overview';

  @service('metrics') metricsService!: MetricsService;

  setupController(controller: BaseController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.getMetricTask.perform();
  }

  resetController(controller: BaseController, isExiting: boolean) {
    if (isExiting) {
      controller.set('unfollow', null);

      this.metricsService.clearMetrics(null, Entities.CAMPAIGN, (this.modelFor(this.routeName) as Model).id);
    }
  }

  redirect(model: any) {
    if (model.isDraft) {
      this.router.transitionTo(`${model.isApiTriggered ? 'broadcasts.broadcast' : 'campaigns.campaign'}.setup`, model);
    }
  }
}
